import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMessagesStore = defineStore('messages', () => {
  const showCreateModal = ref(false)

  function openCreateModal() {
    showCreateModal.value = true
  }

  function closeCreateModal() {
    showCreateModal.value = false
  }

  return {
    showCreateModal,
    openCreateModal,
    closeCreateModal,
  }
})
